import React from 'react'

const CTA = () => {
  return (
    <div className='cta'>
        <a href='#about' className='btn'>Let's meet</a>
        <a href='#contact' className='btn btn-primary'>Let's connect</a>
    </div>
  )
}

export default CTA